// The child helpline named on the safety-pause lines (ADR-0044 point 9). It follows the
// household's country, not the app's language: an English-speaking child in France needs
// the French number. Households carry no country yet and the alpha is French families only,
// so every child gets France's; adding a country is one entry here.

export interface Helpline {
  /** The number as the child dials it. */
  readonly number: string;
}

export const HELPLINES = {
  // Allô Enfance en Danger: free, day and night.
  FR: { number: "119" },
} as const satisfies Readonly<Record<string, Helpline>>;

export type HelplineCountry = keyof typeof HELPLINES;

/** The alpha's only country (EU residency, French families). */
export const ALPHA_COUNTRY: HelplineCountry = "FR";

export function helplineFor(country: HelplineCountry = ALPHA_COUNTRY): Helpline {
  return HELPLINES[country];
}
